let mainPath = "/superadmin";
let viewFolder = "SuperAdmin";

module.exports = [
    {
        path: mainPath,
        name: 'superadmin',
        component: () => import('../views/'+viewFolder+'/Index.vue'),
       
    },
    {
        path: mainPath+'/globals',
        name: 'Globals',
        component: () => import('../views/'+viewFolder+'/Globals.vue'),
       
    },
    {
        path: mainPath+'/appointmentschedule',
        name: 'AppointmentSchedule',
        component: () => import('../views/'+viewFolder+'/AppointmentSchedule.vue'),
       
    },
    {
        path: mainPath+'/customControllers',
        name: 'CustomControllers',
        component: () => import('../views/'+viewFolder+'/CustomControllers.vue'),

    },
    {
        path: mainPath+'/permissions',
        name: 'Permissions',
        component: () => import('../views/'+viewFolder+'/Permissions.vue'),

    },
    {
        path: mainPath+'/dynamicButtonContainers',
        name: 'DynamicButtons',
        component: () => import('../views/'+viewFolder+'/DynamicButtonContainers.vue'),

    },
]